<template>
<div>
    <!-- Modal helper -->
    <modal name="modal-helper-folder-warranty">
        <div v-if="selectedHelper">
            <h2 class="font-bold text-3xl border-b pb-5 mb-5">{{$t('form.garantie.type_garantie')}}</h2>
            <img class="w-full mx-auto" style="max-width: 350px;" :src="selectedHelper.img" />
            <div class="text-center mt-5">
                <button class="px-5 py-2.5 text-sm font-base text-white duration-100 duration-200 bg-red-600 border-red-700 hover:bg-red-700 rounded-xl" @click="$modal.hide('modal-helper-folder-warranty')">
                    <i class="mr-1 fas fa-times"></i> {{$t('form.garantie.fermer')}}
                </button>
            </div>
        </div>
    </modal>

    <!-- Form Card -->
    <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'"> {{$t('form.garantie.type_garantie')}} </h1>
    <sav-fold-card v-model="open" class="mt-4" :close-button="false" :can-open="canOpen"  :id="$options.name">
        <template v-slot:close>
            <template v-if="selected">
                    <div class="text-xs font-bold">
                        <template v-if="selected.length > 0">
                            <div v-for="(obj, index) in selected" v-bind:key="'confirm-' + index">
                                <span class="font-light"> {{obj.labelSelected || obj.label}}: </span>
                                <span class="font-bold">
                                    <a @click.stop="" class="text-blue-500 hover:underline" :href="obj.value.url" v-if="obj.value && checkStringUrl(obj.value.url)" target="_blank">{{$t('form.garantie.consulter_le_fichier')}}</a>
                                    <span class="break-words" v-else>{{obj.value}}</span>
                                </span>
                            </div>
                        </template>
                        <template v-if="selected.length == 0">
                            <span v-if="isWarranty">
                                <i class="mr-1 fas fa-check"></i> {{$t('form.garantie.sous_garantie')}}
                            </span>
                            <span class="text-red-700" v-else>{{$t('form.garantie.hors_garantie')}}</span>
                        </template>
                    </div>
            </template>
        </template>
        <template v-slot:open>
            <sav-spinner v-if="loading" :size="10" />
            <template v-if="!loading">
                <!-- Title warranty -->
                <div class="text-lg font-bold" :class="isWarranty ? 'text-green-600' : 'text-red-700'">
                    <span v-if="isWarranty">
                        <i class="mr-1 fas fa-check"></i> {{$t('form.garantie.sous_garantie')}}
                    </span>
                    <span v-else>{{$t('form.garantie.hors_garantie')}}</span>
                    <div class="py-4 mt-4 text-xs font-light border-t" v-if="subTitle" v-html="subTitle"></div>
                </div>
                <!-- Can't edit -->
                <template v-if="caseAlreadyExists">
                    <div class="p-3 px-4 my-3 text-sm font-bold text-white bg-orange-400 my-rounded">{{$t('form.garantie.le_dossier_est_deja_cree_vous_ne_pouvez_pas_modifier_ces_informations')}}</div>
                </template>
                <!-- no workflow -->
                <div class="py-4 mt-4 text-sm font-light border-t" v-if="textNoWorkflow" v-html="textNoWorkflow"></div>
                <!-- Errors -->
                <ul v-if="errors && errors.length > 0" class="mt-3 mb-4 ml-3 list-disc">
                    <li class="text-sm text-red-500" :key="'error-' + errorIndex" v-for="(error, errorIndex) in errors"> {{error}} </li>
                </ul>
                <sav-form v-if="data && data.length > 0" class="mt-2" :data-src="data" :callback="end" :id="$options.name" :can-submit="!caseAlreadyExists" />
                <template v-if="(!data || data.length <= 0) && $formTool.getFormData('proc').id_workflow != 0">
                    <button test-id="sav-button" @click="end([])" class="px-5 py-2.5 text-sm font-base duration-100 duration-200 bg-gray-200 border-gray-200 hover:bg-gray-300 rounded-xl">
                        Continuer
                    </button>
                </template>
            </template>
        </template>
    </sav-fold-card>
</div>
</template>

<script>
import apiService from '@/services/api.service'
import FormCardExtension from '@/extends/FormCardExtension'
import moment from 'moment'

export default {
    name: 'folder-warranty',
    extends: FormCardExtension,

    data() {
        return {
            textNoWorkflow: null,
            isWarranty: false,
            subTitle: null,
            errors: null,
            selectedHelper: null,
        }
    },

    computed: {
        caseAlreadyExists() {
            let caseExists = this.$formTool.getFormData('set-case')
            return caseExists ? true : false
        },
        inputs() {
            return {
                num_facture: {
                    type: 'text',
                    label: this.$t('form.garantie.numero_de_facture'),
                    key: "invoiceNumber",
                    api_key: "num_facture",
                    disabled: this.caseAlreadyExists,
                    required: false
                },
                num_serie: {
                    type: 'text',
                    label: this.$t('form.garantie.numero_de_serie'),
                    key: "serialNumber",
                    api_key: "num_serie",
                    disabled: this.caseAlreadyExists,
                    required: false
                },
                photo_panne: {
                    type: 'file',
                    label: this.$t('form.garantie.envoyez_nous_une_photo_de_la_panne'),
                    labelSelected: this.$t('form.garantie.photo_de_la_panne'),
                    key: "failurePicture",
                    api_key: "photo_panne",
                    disabled: this.caseAlreadyExists,
                    required: false
                },
                photo_facture: {
                    type: 'file',
                    label: this.$t('form.garantie.envoyez_nous_une_photo_de_la_facture'),
                    labelSelected: this.$t('form.garantie.photo_de_la_facture'),
                    key: "invoicePicture",
                    api_key: "photo_facture",
                    disabled: this.caseAlreadyExists,
                    required: false
                },
                indicesav: {
                    type: 'indice-sav',
                    label: this.$t('form.garantie.indice_sav'),
                    key: "indiceSav",
                    api_key: "indicesav",
                    disabled: this.caseAlreadyExists,
                    required: false
                },
                date_fab: {
                    type: 'date-fabrication',
                    label: this.$t('form.garantie.date_de_fabriquation'),
                    key: "fabricationDate",
                    api_key: "date_fab",
                    disabled: this.caseAlreadyExists,
                    required: false
                },
                accessoire: {
                    type: 'text',
                    label: this.$t('form.garantie.accessoire'),
                    key: "accessory",
                    api_key: "accessoire",
                    disabled: this.caseAlreadyExists,
                    required: false
                },
                imei: {
                    type: 'text',
                    label: this.$t('form.garantie.imei'),
                    key: "imei",
                    api_key: "imei",
                    disabled: this.caseAlreadyExists,
                    required: false
                },
                photo_plaque: {
                    type: 'file',
                    label: this.$t('form.garantie.envoyez_nous_une_photo_du_numero_de_serie'),
                    labelSelected: this.$t('form.garantie.photo_du_numero_de_serie'),
                    key: "PlaquePicture",
                    api_key: "photo_plaque",
                    disabled: this.caseAlreadyExists,
                    required: false
                },
                tel_client: {
                    type: 'tel',
                    label: this.$t('form.garantie.numero_de_telephone'),
                    key: "tel_client",
                    api_key: "tel_client",
                    disabled: this.caseAlreadyExists,
                    required: false
                },
                num_commande: {
                    type: 'text',
                    label: this.$tt('Numéro de commande'),
                    key: "numCommande",
                    api_key: "num_commande",
                    disabled: this.caseAlreadyExists,
                    required: false
                }
            }
        }
    },

    methods: {
        async init() {
            this.loading = true

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.nextBlock = this.nextRoute()
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            // Get api data
            this.data = null
            let requestBody = {
                id_app: this.$formTool.getFormData('device')[0].value.id,
                id_enseigne: this.$formTool.getFormData('sign').id,
                is_extension: this.$formTool.getFormData('extension-warranty') && this.$formTool.getFormData('extension-warranty').exists == true ? 1 : 0
            }
            if (this.$formTool.getFormData('purchase-date')[0].value) {
                requestBody.purchase_date = moment(this.$formTool.getFormData('purchase-date')[0].value, 'DD/MM/YYYY').format('YYYY-MM-DD')
            }
            let onlineId = 0 // 0 -> no online card, 1: only online, 2: only shop
            if (this.$formTool.getFormData('buy-online')) {
                onlineId = this.$formTool.getFormData('buy-online') == 'online' ? 1 : 2
            }
            requestBody.online = onlineId
            requestBody.id_mag = this.$formTool.getFormData('shop') && this.$formTool.getFormData('shop')[0].value ? this.$formTool.getFormData('shop')[0].value.id : 1
            let response = await apiService.post('getproc', requestBody)
            let responseData = response.data.posts.post
            this.$formTool.addFormData('id_proc', responseData.id)
            // responseData.emballage = 1
            this.$formTool.addFormData('proc', responseData)


            // If no workflow, just display text
            if (responseData.id_workflow == 0) {
                let text = await apiService.text('dossier_garantie', this.$formTool.getFormData('proc').id)
                this.textNoWorkflow = this.$tt(text)
            }
            
            // If workflow
            if (responseData.id_workflow != 0) {
                this.isWarranty = responseData.type_garantie == 'hors_garantie' ? false : true
                this.subTitle = await apiService.text('dossier_garantie', this.$formTool.getFormData('proc').id)

                this.data = []
                for (const [key, data] of Object.entries(responseData)) {
                    // Get input type
                    if (data && (data.mandatory == '1' || data.mandatory == '2')) {
                        let endInput = this.inputs[key]
                        if (endInput) {
                            // Set required input
                            if (data.mandatory == 2) {
                                endInput.required = true
                            }
                            // Get input type
                            if (this.inputs[key]) {
                                endInput.value = this.$formTool.getFormData(this.$options.name) ? this.$formTool.getFormData(this.$options.name).find(el => el.api_key == key).value : null
                                endInput.meta = {}

                                // Display helper button
                                if (data.img) {
                                    endInput.modalHelper = this.displayModalHelper
                                    endInput.meta.img = data.img
                                }

                                // CUSTOM CASES
                                    // IndiceSav
                                    if (key == 'indicesav') {
                                        if (!endInput.value) {
                                            endInput.value = this.$formTool.getFormData('device')[0].value['Modele']
                                        }
                                    }

                                    // Tel client
                                    if (key == 'tel_client' && !endInput.value) {
                                        let user = await apiService.getUser()
                                        endInput.value = user.tel
                                    }

                                // Add Input in form object
                                this.data.push(endInput)
                            }
                        }
                    }
                }
            }

            this.loading = false
        },

        async end(callbackData) {
            let endValueStorage = JSON.parse(JSON.stringify(callbackData))

            let dataVerif = {id_app: this.$formTool.getFormData('device')[0].value.id}
            if (callbackData.find(item => item.key === "serialNumber"))
                dataVerif.num_serie = callbackData.find(item => item.key === "serialNumber").value
            if (callbackData.find(item => item.key === "tel_client"))
                dataVerif.tel_client = callbackData.find(item => item.key === "tel_client").value
            if (callbackData.find(item => item.key === "invoiceNumber"))
                dataVerif.invoice_num = callbackData.find(item => item.key === "invoiceNumber").value
            if (callbackData.find(item => item.key === "description"))
                dataVerif.description = callbackData.find(item => item.key === "description").value
            if (callbackData.find(item => item.key === "conditionCode"))
                dataVerif.code_condition = callbackData.find(item => item.key === "conditionCode").value
            if (callbackData.find(item => item.key === "symptomCode"))
                dataVerif.code_symptome = callbackData.find(item => item.key === "symptomCode").value
            if (callbackData.find(item => item.key === "fabricationDate"))
                dataVerif.date_fab = callbackData.find(item => item.key === "fabricationDate").value
            if (callbackData.find(item => item.key === "numCommande"))
                dataVerif.num_commande = callbackData.find(item => item.key === "numCommande").value
            let verifErrorsResponse = await apiService.post('verifproc', dataVerif)
            let errors = verifErrorsResponse.data.posts.error

            if (errors) {
                this.errors = [errors]
            } else {
                this.$formTool.addFormData(this.$options.name, endValueStorage)
                this.nextBlock = this.nextRoute()
                if (this.selected) {
                    this.$emit('update', this.$options.name)
                }
                this.selected = JSON.parse(JSON.stringify(callbackData))
            }
        },

        displayModalHelper(meta) {
            this.selectedHelper = meta
            this.$modal.show('modal-helper-folder-warranty')
        },

        nextRoute() {
            if (this.$formTool.getFormData('sign') && this.$formTool.getFormData('sign').selfcare_process_choice && this.$formTool.getFormData('sign').selfcare_process_choice == 1) {
                return this.$formTool.blockData(this.$options.name).next.chooseProcess
            }
            if (!this.$formTool.getFormData('proc').adresse_client || this.$formTool.getFormData('proc').adresse_client.mandatory == '1') {
                return this.$formTool.blockData(this.$options.name).next.address
            } else {
                return this.$formTool.blockData(this.$options.name).next.default
            }
        },

        checkStringUrl(string) {
            let url;
            
            try {
                url = new URL(string);
            } catch (_) {
                return false;  
            }

            return url.protocol === "http:" || url.protocol === "https:";
        },
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/warranty/FolderWarrantyCard.vue